// src/number.ts
var hexEncodeNumber = (num) => `0x${num.toString(16)}`;
export {
  hexEncodeNumber
};
